export const FEATURE_KEYS = [
  'dashboard',
  'events',
  'projects',
  'committee',
  'timeline',
  'gallery',
  'reviews',
  'notices',
  'classes',
  'contactSettings',
  'users',
  'roles',
  'telemetry',
  'systemHealth',
  'blog',
  'media',
] as const;

export type FeatureKey = (typeof FEATURE_KEYS)[number];

export const PERMISSION_LEVELS = ['none', 'view', 'edit', 'delete', 'admin'] as const;
export type PermissionLevel = (typeof PERMISSION_LEVELS)[number];

export type EffectivePermissions = Record<FeatureKey, PermissionLevel>;

export type RolePermissionsPayload = Partial<Record<FeatureKey, PermissionLevel>>;

export interface RolePermissionsResponse {
  roleId: string;
  roleName: string;
  displayName: string;
  effectivePermissions: EffectivePermissions;
}
